import React, { Component } from 'react';

class Dashboard extends Component {
    render() {
        return (
            <div>
                <div className="card-deck">
                    <div className="card text-center border-main">
                        <div className="card-header  bg-main text-white">
                            <h3>Available Stock</h3>
                        </div>
                        <div className="card-body txt-main">
                            <h4>450</h4>
                        </div>
                    </div>
                    <div className="card text-center border-main">
                        <div className="card-header  bg-main text-white">
                            <h3>Monthly Income</h3>
                        </div>
                        <div className="card-body txt-main">
                            <h4>Rs.22500.00</h4>
                        </div>
                    </div>
                    <div className="card text-center border-main">
                        <div className="card-header  bg-main text-white">
                            <h3>Units Sold</h3>
                        </div>
                        <div className="card-body txt-main">
                            <h4>85</h4>
                        </div>
                    </div>
                    <div className="card text-center border-main">
                        <div className="card-header  bg-main text-white">
                            <h3>Gross Profit</h3>
                        </div>
                        <div className="card-body txt-main">
                            <h4>Rs.15000.00</h4>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Dashboard;
